import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import crypto from "../../Assets/Projects/cryptod5.png";
import base from "../../Assets/Projects/base.png";
import defi from "../../Assets/Projects/defi.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={crypto}
              isBlog={false}
              title="CryptoD5.com"
              description="This project addresses the need to monitor and track illegal activities performed using cryptocurrency transaction technology. The goal is to develop tools and techniques to de-anonymize activities on the dark web and in cryptocurrency transactions."
              //ghLink="https://github.com/soumyajit4419/Plant_AI"
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={base}
              isBlog={false}
              title="IPFS Store & Verify"
              description="Utilizes blockchain technology for secure file storage and validation of government-issued certificates."
              ghLink="https://github.com/Annapurna138/blockchian-based-document-verification"
              demoLink="https://github.com/Annapurna138/blockchian-based-document-verification"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={defi}
              isBlog={false}
              title="Network Log Visualization"
              description="Create a tool that visualizes network logs and uses machine learning to detect anomalies, enabling the identification of security threats and system issues
"
              ghLink="https://github.com/Annapurna138/network-log-visualization-and-anomaly-detection"
              demoLink="https://github.com/Annapurna138/network-log-visualization-and-anomaly-detection"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
